import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';
import logo from '../logo.png';

export default function TenantSelector() {
  const { user, logout } = useAuth();
  const { tenants, loading, switchTenant, activeTenant, closeSwitcher, enterPersonalMode, personalMode } = useTenant();

  // canCancel = der User hat schon einen aktiven Mandanten oder ist gerade im
  // Privat-Modus und ist nur kurz hier auf der Switcher-Seite. Dann darf er
  // auch ohne Wechsel zurück. Wer noch nie etwas gewählt hat, hat nichts wohin.
  const canCancel = !!activeTenant || personalMode;

  return (
    <div className="tenant-selector-page">
      <div className="tenant-selector-card">
        <div className="tenant-selector-header">
          <div className="tenant-selector-brand">
            <img
              src={logo}
              alt="NextVersion AI Logo"
              className="tenant-selector-logo"
            />
            <p className="tenant-selector-subtitle">
              Willkommen, <strong>{user?.username}</strong> —{' '}
              {tenants.length > 0
                ? 'wähle einen Mandanten.'
                : 'du wartest auf eine Einladung in einen Mandanten.'}
            </p>
          </div>
          <div className="tenant-selector-header-actions">
            {canCancel && (
              <button className="link-btn" onClick={closeSwitcher}>
                ✕ Abbrechen
              </button>
            )}
            <button className="link-btn" onClick={logout}>Abmelden</button>
          </div>
        </div>

        {loading && <p>Lädt…</p>}

        {!loading && tenants.length > 0 && (
          <div className="tenant-list">
            {tenants.map(t => (
              <button
                key={t._id}
                className="tenant-card"
                onClick={() => switchTenant(t._id)}
              >
                <div className="tenant-card-icon">🏢</div>
                <div className="tenant-card-body">
                  <div className="tenant-card-name">{t.name}</div>
                  <div className="tenant-card-role">Rolle: {t.role}</div>
                </div>
                <div className="tenant-card-arrow">→</div>
              </button>
            ))}
          </div>
        )}

        {!loading && tenants.length === 0 && (
          <div className="tenant-empty">
            <p>
              Du bist aktuell <strong>keinem Mandanten zugeordnet</strong>.
              Bitte einen Admin, dich zu einem Mandanten hinzuzufügen oder einen für dich anzulegen.
            </p>
            <p className="tenant-empty-hint">
              Du bleibst eingeloggt — sobald jemand dich einlädt, erscheint der Mandant hier.
            </p>
          </div>
        )}

        {/* Privat-Modus: kein Mandant, nur KI-Chat. Immer verfügbar — auch
            für User die einen Mandanten haben, falls sie privat etwas
            fragen wollen ohne dass es im Mandantenkontext landet. */}
        {!loading && (
          <div className="tenant-personal-section">
            <div className="tenant-personal-divider"><span>oder</span></div>
            <button className="tenant-card tenant-card-personal" onClick={enterPersonalMode}>
              <div className="tenant-card-icon">🏠</div>
              <div className="tenant-card-body">
                <div className="tenant-card-name">Privat weitermachen</div>
                <div className="tenant-card-role">
                  Nur KI-Chat — keine Workflows, Aufgaben oder Datenquellen
                </div>
              </div>
              <div className="tenant-card-arrow">→</div>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
